var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfinity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 10,
    viewBox: "0 0 22 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8005 5C10.7582 5.06012 10.7123 5.12444 10.6627 5.19239C10.3417 5.63301 9.87797 6.21742 9.30568 6.798C8.12114 7.9997 6.65441 9 5.14286 9C2.82808 9 1 7.18277 1 5C1 2.81723 2.82808 1 5.14286 1C6.65441 1 8.12114 2.0003 9.30568 3.202C9.87797 3.78258 10.3417 4.36699 10.6627 4.80761C10.7123 4.87556 10.7582 4.93988 10.8005 5Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5C21 7.18277 19.1719 9 16.8571 9C15.3456 9 13.8789 7.9997 12.6943 6.798C12.122 6.21742 11.6583 5.63301 11.3373 5.19239C11.2877 5.12444 11.2418 5.06012 11.1995 5C11.2418 4.93988 11.2877 4.87556 11.3373 4.80761C11.6583 4.36699 12.122 3.78258 12.6943 3.202C13.8789 2.0003 15.3456 1 16.8571 1C19.1719 1 21 2.81723 21 5Z",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.8c57c174f2cbd9eeb2009aaaa2c4b621.svg";
export { ForwardRef as ReactComponent };